import { supabase } from '@/integrations/supabase/client';

export interface Notification {
  id: string;
  user_id: string;
  type: 'sale' | 'offer' | 'return' | 'low_stock' | 'price_alert' | 'system';
  title: string;
  body: string;
  read: boolean;
  metadata: Record<string, unknown>;
  created_at: string;
}

export const notifications = {
  async fetchNotifications(limit = 20) {
    const { data, error } = await supabase
      .from('notifications')
      .select('id, user_id, type, title, body, read, metadata, created_at')
      .order('created_at', { ascending: false })
      .limit(limit);
    if (error) throw error;
    return data as Notification[];
  },

  async getUnreadCount() {
    const { count, error } = await supabase
      .from('notifications')
      .select('*', { count: 'exact', head: true })
      .eq('read', false);
    if (error) return 0;
    return count ?? 0;
  },

  async markRead(id: string) {
    const { error } = await supabase.from('notifications').update({ read: true }).eq('id', id);
    if (error) throw error;
  },

  async markAllRead() {
    const { error } = await supabase.from('notifications').update({ read: true }).eq('read', false);
    if (error) throw error;
  },
};
